import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Table, Tag } from "antd";
import { getPolicyAcknowledgementStatus } from "../../services/policyServices";

const PolicyAcknowledgementStatusModal = ({
  show,
  handleClose,
  policyId,
  policyVersion,
  policies,
}) => {
  const [acknowledgementData, setAcknowledgementData] = useState([]);
  const [selectedPolicyId, setSelectedPolicyId] = useState(policyId);
  const [selectedPolicyVersion, setSelectedPolicyVersion] =
    useState(policyVersion);

  const fetchPolicyAcknowledgementStatus = async (policyId, policyVersion) => {
    try {
      const response = await getPolicyAcknowledgementStatus(
        policyId,
        policyVersion
      );
      setAcknowledgementData(response.acknowledgmentStatus ?? []);
    } catch (error) {
      console.error("Error fetching policy acknowledgement status:", error);
    }
  };

  useEffect(() => {
    if (show && selectedPolicyId && selectedPolicyVersion) {
      fetchPolicyAcknowledgementStatus(selectedPolicyId, selectedPolicyVersion);
    }
  }, [show, selectedPolicyId, selectedPolicyVersion]);

  const handleDropdownChange = (event) => {
    const selectedPolicy = policies.find(
      (policy) => policy.id == event.target.value
    );
    if (selectedPolicy) {
      setSelectedPolicyId(selectedPolicy.id);
      setSelectedPolicyVersion(selectedPolicy.policy_version_id);
      fetchPolicyAcknowledgementStatus(
        selectedPolicy.id,
        selectedPolicy.policy_version_id
      );
    } else {
      setAcknowledgementData([]);
    }
  };

  const getStatusTag = (status) => {
    switch (status) {
      case "ACKNOWLEDGED":
        return <Tag color="green">{status}</Tag>;
      case "PENDING":
        return <Tag color="gold">{status}</Tag>;
      default:
        return <Tag>{status}</Tag>;
    }
  };

  const columns = [
    {
      title: "EMPLOYEE ID",
      dataIndex: "employment_id",
      key: "employment_id",
      render: (text, record) => <span>{record.employment_id ?? "-"}</span>,
    },
    {
      title: "EMPLOYEE NAME",
      key: "name",
      render: (text, record) => (
        <span>
          {record.first_name}{" "}
          {record.middle_name ? record.middle_name + " " : ""}
          {record.last_name}
        </span>
      ),
    },
    {
      title: "DEPARTMENT",
      dataIndex: "department_name",
      key: "department_name",
    },
    {
      title: "STATUS",
      dataIndex: "acknowledgment_status",
      key: "acknowledgment_status",
      render: (status) => getStatusTag(status),
    },
    {
      title: "ACKNOWLEDGEMENT DATE",
      dataIndex: "acknowledgment_date",
      key: "acknowledgment_date",
      render: (date) => <span>{date ?? "-"}</span>,
    },
  ];

  return (
    <Modal show={show} size="xl" centered>
      <Modal.Header>
        <Modal.Title>Policy Acknowledgement Status</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>Select Policy:</Form.Label>
          <Form.Select
            defaultValue={policyId}
            onChange={handleDropdownChange}
            style={{ width: "auto" }}
          >
            {policies?.map((policy) => (
              <option key={policy.id} value={policy.id}>
                {policy.policy_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Table
          columns={columns}
          dataSource={acknowledgementData}
          pagination={{ pageSize: 10 }}
          scroll={{ x: "max-content" }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PolicyAcknowledgementStatusModal;
